import classNames from 'classnames';
import * as React from 'react';
import type { BreadcrumbsViewModel } from '~/Features/Breadcrumbs/BreadcrumbsViewModel.csharp';
import styles from './Breadcrumbs.module.css';

export interface BreadcrumbsProps extends BreadcrumbsViewModel {
    className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = props => {
    const { breadcrumbs, className } = props;

    return (
        <ol className={classNames(styles.Breadcrumbs, className)} id="breadcrumbs">
            {breadcrumbs.map(breadcrumb => (
                <li key={`${breadcrumb.name}}`}>
                    <a className={styles.Link} href={breadcrumb.link}>
                        {breadcrumb.name}
                    </a>
                </li>
            ))}
        </ol>
    );
};
